function downloadFile (blob, fileName) {
  const a = document.createElement('a')
  document.body.appendChild(a)
  a.href = window.URL.createObjectURL(blob)
  a.download = fileName
  a.click()
  window.URL.revokeObjectURL(a.href)
  a.remove()
}

export default {
  downloadFile
}
